export const jobMock = {
	"applySessionType": "4",
	"billingAccountId": "127144",
	"brandId": 24549,
	"brandTemplateName": "Aerotek",
	"jobDescription": "<p>Will be working outage and repair jobs <br><br>Summary of Industrial Service Pipe Fitter/Welder<br>This individual will perform on site installation, maintenance, and upgrades to machinery, equipment, and facilities according to verbal, written instruction, PI&Ds, engineered drawings and schematics.<br><br>Responsibilities of Industrial Service Pipe Fitter/Welder<br>- Perform in the field using related experience and knowledge of codes and specifications.<br>- Reads and deciphers work scope, engineered drawings, and PI&Ds to determine work procedures and build method.<br>- Works with Installation group at the customer work site.<br>- Dismantle, move, rig, assemble, and install process equipment, machinery as well as facility upgrades.<br>- Install necessary piping to equipment as well as facility upgrades.<br>- Assembles machinery, bolts, welds, or otherwise fastens them to foundation or other structures.<br>- Repairs, lubricates, and service machinery and equipment per specifications.<br>- Works in a safe manner according to company and site safety standards.<br><br><br></p><p><strong>About Aerotek:</strong></p><p>Aerotek, headquartered in Hanover, Md., is a leading provider of technical, professional and industrial staffing services.  Established in 1983, Aerotek is an operating company of Allegis Group, the largest provider of staffing services in the U.S. Aerotek operates a network of more than 200 non-franchised offices throughout the U.S., Canada and Europe. For more information, visit Aerotek.com.</p><p> </p>",
	"postedDate": "2014-08-12T04:00:00+00:00",
	"primaryIndustryId": 27,
	"qualifications": {
		"driving": null,
		"languages": null,
		"minimumAge": 0,
		"skills": null,
		"jobRequirement": null,
		"jobBenefits": null,
		"jobIndustries": [
			"Retail"
		],
		"billingAccountDescription": null
	},
	"addressLine1": "Swedesboro, NJ",
	"addressLine2": null,
	"applicationURL": "http://www.aplitrak.com/?adid=YmJnZW5lcmljLjMyNzYwLjQyNjJAYWxsZWdpc2Flcm90ZWsuYXBsaXRyYWsuY29t&AdCode=Snag2068",
	"brandTemplateId": 18148,
	"categories": [
		"Full-time",
		"Part-time"
	],
	"city": "Swedesboro",
	"company": "Aerotek",
	"county": "Gloucester",
	"id": "5918070",
	"industries": [
		"Retail"
	],
	"jobTitle": "Welder",
	"latitude": "39.757",
	"longitude": "-75.3338",
	"postalCode": "08085",
	"stateProvCode": "NJ"
}